export default {
  computed: {
    currentCard() {
      return this.$store.state.cards.currentCard
    },

    userAlerts() {
      return this.currentCard.alerts.filter((a) => a.activity.is_active)
    },

    isActivityActive() {
      return (id) => {
        return this.currentCard.alerts.some((a) => a.activity.id == id)
      }
    },
  },
}
